import { memo, useCallback, useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import { Input, Popover } from '@mantine/core'
import { IconCalendar } from '@tabler/icons'
import { dayjsInit } from '@ow/utils'
import Single from './single'
import Multi from './multi'

const MontPicker = ({
  className,
  style,
  placeholder = '请选择月份',
  value,
  onChange,
  isMulti,
}) => {
  const inputRef = useRef(null)
  const [popOverWidth, setPopOverWidth] = useState(isMulti ? 640 : 320)
  const [opened, setOpened] = useState(false)

  const getValue = () => {
    if (isMulti) {
      if (value) {
        const { startDate, endDate } = value
        if (startDate && endDate) {
          return (
            dayjsInit(startDate).format('YYYY/MM') +
            '-' +
            dayjsInit(endDate).format('YYYY/MM')
          )
        }
      }
      return placeholder
    }

    if (value) {
      return dayjsInit(value).format('YYYY/MM')
    }

    return placeholder
  }

  const handleChange = useCallback(
    (v) => {
      if (onChange) {
        onChange(v)
      }
    },
    [onChange]
  )

  const onClose = useCallback(() => {
    setOpened(false)
  }, [])

  useEffect(() => {
    if (inputRef.current) {
      // 设置弹出层大小为输入框宽度，最小宽度320/640
      setPopOverWidth((pre) => Math.max(pre, inputRef.current.clientWidth))
    }
  }, [])
  return (
    <Popover opened={opened} width={popOverWidth} position="bottom-start">
      <Popover.Target>
        <Input
          ref={inputRef}
          className={clsx('w-[200px] h-[34px] text-gray-300', className)}
          style={style}
          component="button"
          onClick={() => setOpened((pre) => !pre)}
          rightSection={<IconCalendar size={18} />}
        >
          <span className="text-gray-300">{getValue()}</span>
        </Input>
      </Popover.Target>
      <Popover.Dropdown className="p-0">
        {isMulti ? (
          <Multi value={value} onChange={handleChange} onClose={onClose} />
        ) : (
          <Single value={value} onChange={handleChange} onClose={onClose} />
        )}
      </Popover.Dropdown>
    </Popover>
  )
}

export default memo(MontPicker)
